export default __webpack_public_path__ + "static/media/commonsdistrict.022596d8.jpg";